import getWithToken from './base/get-with-token'

const getCustomersTimeline = (id, type) => getWithToken(`/customer/${id}/timeline`)({
  type
})

export default getCustomersTimeline